<template>
  <div class="app-top" :style="{ 'height': topHeightNum + 'px' }">
    <div class="app-top-fixed" :style="{ 'height': topHeightNum + 'px', 'background-color': colorTopBg }"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      colorTopBg:"",
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.colorTopBg = val.meta.color;
      },
      // 深度观察监听
      immediate: true
    }
  }
}
</script>
<style>
.app-top {
  width: 100%;
}

.app-top-fixed {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
</style>


// WEBPACK FOOTER //
// src/components/drTop/index.vue